import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Paging } from '../../../model/paging/paging';
import { Obstacle } from '../../../model/obstacle/obstacle';

@Injectable({
    providedIn: 'root'
})
export class ObstacleService_Mock {

    GETPaginatedObstacles(paging:Paging, name?: string): Observable<Obstacle>  | any{
        const allData = [
            {
                materialId: "wall-concrete",
                name: "Wall - Concrete",
                attenuations: { freq24: 12.5, freq5: 18.2, freq6: 22.1 },
                colorHex: "#808080"
            },
            {
                materialId: "glass-panel",
                name: "Glass Panel",
                attenuations: { freq24: 3.0, freq5: 5.5, freq6: 7.0 },
                colorHex: "#ADD8E6"
            },
            {
                materialId: "drywall-standard",
                name: "Drywall - Standard",
                attenuations: { freq24: 4.5, freq5: 6.8, freq6: 8.1 },
                colorHex: "#D2B48C"
            },
            {
                materialId: "metal-door",
                name: "Metal Door",
                attenuations: { freq24: 15.0, freq5: 22.0, freq6: 27.5 },
                colorHex: "#5F6C7B"
            },
            {
                materialId: "wood-solid",
                name: "Wood - Solid",
                attenuations: { freq24: 6.0, freq5: 9.5, freq6: 11.0 },
                colorHex: "#8B4513"
            },
        ];
        const term = name?.trim().toLowerCase() ?? "";
        const filteredData = !term
            ? allData
            : allData.filter((item) => item.name.toLowerCase().includes(term) || item.materialId.toLowerCase().includes(term));
        const start = (paging.pageIndex - 1) * paging.pageSize;
        const end = start + paging.pageSize;
        const pageData = filteredData.slice(start, end);
        const mockData = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 10,
            data: {
                count: filteredData.length,
                items: pageData
            }
        };

        return of(mockData);
    }

    GETObstacleById(obstacleId:string): Observable<Obstacle>  | any{
       const obstacleDetails = this.getMockObstacle(obstacleId);

        const mockData = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 8,
            data: obstacleDetails
        };

        return of(mockData);
    }

    DELETEObstacle(obstacleId:string){
        const mockResponse = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 7,
            data: true
        };

        return of(mockResponse);        
    }   

    POSTObstacle(body:Obstacle){
        const mockResponse = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 9,
            data: true
        };

        return of(mockResponse);
    }

    PUTObstacle(obstacleId:string, body:Obstacle){
        const mockResponse = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 9,
            data: true
        };

        return of(mockResponse);
    }

    private getMockObstacle(obstacleId: string) {
        const obstacles = [
            { materialId: "wall-concrete", name: "Wall - Concrete", attenuations: { freq24: 12.5, freq5: 18.2, freq6: 22.1 }, colorHex: "#808080" },
            { materialId: "glass-panel", name: "Glass Panel", attenuations: { freq24: 3.0, freq5: 5.5, freq6: 7.0 }, colorHex: "#ADD8E6" },
            { materialId: "drywall-standard", name: "Drywall - Standard", attenuations: { freq24: 4.5, freq5: 6.8, freq6: 8.1 }, colorHex: "#D2B48C" },
            { materialId: "metal-door", name: "Metal Door", attenuations: { freq24: 15.0, freq5: 22.0, freq6: 27.5 }, colorHex: "#5F6C7B" },
            { materialId: "wood-solid", name: "Wood - Solid", attenuations: { freq24: 6.0, freq5: 9.5, freq6: 11.0 }, colorHex: "#8B4513" }
        ];
        return obstacles.find((obstacle) => obstacle.materialId === obstacleId) ?? obstacles[0];
    }
}
